var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",on:{"click":function($event){return _vm.toHome()}}},[_c('img',{attrs:{"src":require("../assets/home/err404.png"),"alt":""}}),_c('p',{staticClass:"errText"},[_vm._v("很抱歉，您要访问的页面貌似走丢了，我们正在努力寻找")])])}
var staticRenderFns = []

export { render, staticRenderFns }